import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";

export const H2 = "font-display text-3xl sm:text-4xl font-extrabold uppercase tracking-tight leading-[1.05] text-slate-900";
export const GRAD = "text-transparent bg-clip-text bg-gradient-to-r from-rose-500 via-pink-500 to-fuchsia-500";

export const Eyebrow = ({ icon: Icon = Sparkles, children }) => (
  <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/90 border border-pink-200 text-rose-600 text-xs font-bold shadow-sm backdrop-blur"><Icon className="w-3.5 h-3.5" /> {children}</span>
);

export const SectionHead = ({ eyebrow, icon, title, accent, lead, className = "", children }) => (
  <div className={`max-w-2xl space-y-3 fade-up ${className}`}>
    {eyebrow && <Eyebrow icon={icon}>{eyebrow}</Eyebrow>}
    <h2 className={H2}>{title}{accent && <> <span className={GRAD}>{accent}</span></>}</h2>
    {lead && <p className="text-base sm:text-lg text-slate-600 leading-relaxed">{lead}</p>}
    {children}
  </div>
);

export const PhoneShot = ({ src, alt, chips = [], tilt = 2, testId }) => (
  <div className="relative mx-auto w-[210px] sm:w-[250px]" data-testid={testId}>
    <div className="absolute -inset-10 rounded-full bg-gradient-to-tr from-rose-200/50 to-fuchsia-200/40 blur-3xl" aria-hidden />
    <motion.div initial={{ opacity: 0, y: 30, rotate: 0 }} whileInView={{ opacity: 1, y: 0, rotate: tilt }} viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.7, ease: "easeOut" }}
      className="relative rounded-[2.5rem] bg-slate-900 p-2.5 shadow-2xl shadow-rose-300/50 hover:rotate-0 transition-transform duration-700">
      <span className="absolute top-4 left-1/2 -translate-x-1/2 w-20 h-4 rounded-full bg-slate-900 z-10" aria-hidden />
      <img src={src} alt={alt} loading="lazy" className="w-full aspect-[390/844] object-cover object-top rounded-[2rem] bg-white" />
    </motion.div>
    {chips.map(({ icon: I, title, sub }, i) => (
      <motion.div key={title} initial={{ opacity: 0, scale: 0.8 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ delay: 0.4 + i * 0.2, type: "spring" }}
        className={`absolute ${i % 2 ? "-right-6 bottom-16" : "-left-8 top-24"} z-20 flex items-center gap-2 px-3 py-2 rounded-2xl bg-white/95 backdrop-blur border border-pink-100 shadow-xl shadow-rose-200/50`}>
        <span className="w-8 h-8 rounded-full bg-rose-50 text-rose-500 flex items-center justify-center"><I className="w-4 h-4" /></span>
        <span className="leading-tight"><b className="block text-xs text-slate-800">{title}</b>{sub && <span className="text-[10px] text-slate-400">{sub}</span>}</span>
      </motion.div>
    ))}
  </div>
);
